"use strict";

const ContextIsolationContents = require('../andapp_client/ContextIsolationContents.js')
let andapp = window.andapp

if (typeof andapp === 'undefined') {
  andapp = {portalapp: { appStatus: {} }}
  ContextIsolationContents.initContents(andapp.portalapp, [
    {name: 'getClientInformation', isFunction: true}
  ])
}


(() => {
  if (AndApp.Device.isAndAppClient() && $("#js-clientInformation").length > 0) {
    andapp.portalapp.getClientInformation().then(
      (result) => {
        const strResult = JSON.stringify(result);
        $("#js-clientInformation").val(strResult);
      },
      (err) => {
        console.error(err);
      }
    );
  }

  $("#js-inquirySend").click((e) => {
    $(e.currentTarget).addClass("is-disabled");
    window.setTimeout(() => {
      $(e.currentTarget).removeClass("is-disabled");
    }, 30000);
  });

})();

